import styled from "styled-components";

function Introduction({ locale }) {
  switch (locale) {
    default:
      return (
        <Paragraph>
          As a passionate and dedicated web developer, I specialize in <Strong>crafting dynamic, user-friendly applications</Strong> with <Strong>JavaScript, TypeScript, Java and other frameworks, libraries</Strong>. 
          <br/>My <Strong>meticulous attention to detail</Strong> and <Strong>innovative approach</Strong> ensure every project is both functional and visually captivating.
          <br/>I thrive on <Strong>collaboration</Strong>, leveraging the power of <Strong>teamwork</Strong> to solve complex problems and deliver exceptional results. 
          <br/>My experience includes <Strong>leading successful projects</Strong>, <Strong>mentoring peers</Strong>, and <Strong>contributing to open-source communities</Strong>, all while fostering a <Strong>creative and productive environment</Strong>.
          <br/>Staying ahead of <Strong>technological trends</Strong> is my commitment, enabling me to provide <Strong>high-quality, efficient, and scalable solutions</Strong>. 
          <br/>If you seek a developer who combines <Strong>technical expertise</Strong> with a <Strong>creative flair</Strong>, let's collaborate and turn your vision into reality.
        </Paragraph>
      );
  }
}

export default Introduction;

const Paragraph = styled.p`
  display: block;

  line-height: 1.5;
  line-break: auto;

  font-size: 2.5vw;
  font-family: "Neue Montreal";
  font-weight: 300;
`;

const Strong = styled.strong`
  font-weight: 600;
`;
